if (!customElements.get('product-variant-tabs')) {
    class ProductVariantTabs extends HTMLElement {
      constructor() {
        super();
        this.tabs = this.querySelectorAll('.variant-tabs__tab');
        this.panels = this.querySelectorAll('.variant-tabs__content');
      }

      connectedCallback() {
        this.setupTabs();
      }

      setupTabs() {
        // Get the tabs container for scrolling
        this.tabsContainer = this.querySelector('.variant-tabs__tabs-content');

        // Get left and right buttons and store as instance properties
        this.leftButton = this.querySelector('.variant-tabs__tabs-left');
        this.rightButton = this.querySelector('.variant-tabs__tabs-right');

        this.tabs.forEach(tab => {
          tab.addEventListener('click', () => {
            const tabId = tab.dataset.tab;

            this.tabs.forEach(t => t.classList.remove('active'));
            this.panels.forEach(p => p.classList.remove('active'));

            tab.classList.add('active');
            const panel = this.querySelector(`[data-panel="${tabId}"]`);
            if (panel) {
              panel.classList.add('active');
            }

            // Scroll the active tab into view, centered if possible
            this.scrollTabIntoView(tab);

            // Update button states after tab change
            this.updateButtonStates();
          });
        });

        // Add left and right tab navigation
        if (this.leftButton) {
          this.leftButton.addEventListener('click', () => {
            this.switchTab(-1);
          });
        }

        if (this.rightButton) {
          this.rightButton.addEventListener('click', () => {
            this.switchTab(1);
          });
        }

        // Initialize button states on load
        this.updateButtonStates();
      }

      scrollTabIntoView(tab) {
        if (!this.tabsContainer) return;

        const tabRect = tab.getBoundingClientRect();
        const containerRect = this.tabsContainer.getBoundingClientRect();

        // Calculate the desired scroll position to center the tab
        const scrollLeft = this.tabsContainer.scrollLeft + tabRect.left - containerRect.left - containerRect.width / 2 + tabRect.width / 2;

        // Animate the scroll
        this.tabsContainer.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
      }

      switchTab(direction) {
        const activeTabIndex = Array.from(this.tabs).findIndex(tab => tab.classList.contains('active'));
        let newIndex;

        if (direction === -1) {
          // Move left - only if not already on the first tab
          if (activeTabIndex > 0) {
            newIndex = activeTabIndex - 1;
            this.tabs[newIndex].click();
          }
        } else {
          // Move right - only if not already on the last tab
          if (activeTabIndex < this.tabs.length - 1) {
            newIndex = activeTabIndex + 1;
            this.tabs[newIndex].click();
          }
        }
      }

      updateButtonStates() {
        const activeTabIndex = Array.from(this.tabs).findIndex(tab => tab.classList.contains('active'));

        // Disable left button if on first tab
        if (this.leftButton) {
          if (activeTabIndex === 0) {
            this.leftButton.classList.add('disabled');
            this.leftButton.setAttribute('disabled', 'disabled');
          } else {
            this.leftButton.classList.remove('disabled');
            this.leftButton.removeAttribute('disabled');
          }
        }

        // Disable right button if on last tab
        if (this.rightButton) {
          if (activeTabIndex === this.tabs.length - 1) {
            this.rightButton.classList.add('disabled');
            this.rightButton.setAttribute('disabled', 'disabled');
          } else {
            this.rightButton.classList.remove('disabled');
            this.rightButton.removeAttribute('disabled');
          }
        }
      }
    }

    customElements.define('product-variant-tabs', ProductVariantTabs);
}
